import UsuarioService from "../../../../modules/Usuario/application/UsuarioService"
import {Boton, Imagen, Spinner, Icon} from 'asocomponents'
import { useForm } from "react-hook-form"
import { mostrarMensaje } from "../../../helpers/mensajeria"
import { useNavigate } from "react-router-dom"
import { useState } from "react"
import { useDispatch } from "react-redux"
import { addUser } from "../../../redux/userSlice"
import {WEBURLEGALES} from "../../../helpers/frontend.js"
import { MENSAJESAPP } from "../../../const/constantes.js";

function LoguinForm() {
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(false)
  const dispatch = useDispatch()
  const [showPassword, setShowPassword] = useState(false)

  const {
    register,
    handleSubmit,
    formState,
    formState: { errors },
  } = useForm({ defaultValues: { usuario: "", password: "" } })

  const redireccionar = () => navigate("/home")

  const enviarForm = async (data) => {
    if (sessionStorage.length > 0) sessionStorage.clear()

    const usuarioService = new UsuarioService(data.usuario, data.password)
    try {
      setIsLoading(true)
      const usuarioValidado = await usuarioService.validarUsuario()
      if (usuarioValidado.autorizado) {
        dispatch(addUser(usuarioValidado))
        localStorage.setItem("menuOpen","true")
        redireccionar()
      } else {
        mostrarMensaje(MENSAJESAPP.LOGIN.USUARIONOVALIDO, "error", 1500)
      }
    } catch (error) {
      mostrarMensaje(MENSAJESAPP.LOGIN.ERRORALVALIDARUSUARIO, "error", 1500)
    } finally {
      setIsLoading(false)
    }
  }

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword)
  }

  return (
    <div className="flex items-center justify-center h-screen">
      <div
        className="bg-center bg-no-repeat bg-fixed"
        style={{
          background: `url('${WEBURLEGALES}/images/fondo-loguin.png')`,
          height: 560,
          width: 1370,
        }}
      >
        <div className="container mx-auto p-8">
          <div className="bg-white bg-opacity-100 w-[35%] h-96 mx-auto relative">
            <div className="absolute top-20 left-1/2 w-[60%] transform -translate-x-1/2 -translate-y-1/2 bg-white h-20">
              <form
                className="w-full mx-auto"
                onSubmit={handleSubmit(enviarForm)}
              >
                <div className="flex justify-center mb-5">
                  <Imagen
                    size="9"
                    source={
                      WEBURLEGALES + "/images/logotipo-asociart.png"
                    }
                    alt="Asociart Logo"
                  />
                </div>
                <div className="mb-1">
                  <label className="block mb-2 text-sm font-medium text-gray-900">
                    Usuario
                  </label>
                  <input
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                    {...register("usuario", {
                      required: {
                        value: true,
                        message: "* El usuario es obligatorio",
                      },
                      minLength: {
                        value: 10,
                        message: "* El usuario no puede tener menos de 11 caracteres",
                      },
                      maxLength: {
                        value: 11,
                        message:
                          "* El usuario no puede superar los 11 caracteres",
                      },
                    })}
                  />
                </div>
                {errors.usuario && (
                  <span className="text-asociart-custom text-xs">
                    {errors.usuario.message}
                  </span>
                )}
                <div className="mt-5 mb-1">
                  <label className="block mb-2 text-sm font-medium text-gray-900">
                    Contraseña
                  </label>
                  <div className="relative">
                    <input
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 pr-10"
                      type={showPassword ? "text" : "password"}
                      {...register("password", {
                        required: {
                          value: true,
                          message: "* La password es obligatoria",
                        },
                        minLength: {
                          value: 6,
                          message:
                            "* La password debe contener al menos 6 caracteres",
                        },
                      })}
                    />
                    <button
                      type="button"
                      onClick={togglePasswordVisibility}
                      className="absolute inset-y-0 right-0 flex items-center px-2"
                    >
                      {showPassword ? (
                        <Icon type="eyeslash" alt="Ocultar Password" />
                      ) : (
                        <Icon type="eye" alt="Mostrar Password" />
                      )}
                    </button>
                    {errors.password && <p>{errors.password.message}</p>}
                  </div>
                </div>

                {errors.password && (
                  <span className="text-asociart-custom text-xs">
                    {errors.password.message}
                  </span>
                )}
                <div className="flex justify-center mt-5 mb-5">
                  <Boton
                    texto="Ingresar"
                    fondo="rojo"
                    type="submit"
                    disabled={formState.isSubmitting}
                  />
                </div>
                {isLoading && <Spinner color="red" size="30" />}
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LoguinForm
